import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupK2 } from '../../../../../../../redux/app/annex6-v2/groups/group-k';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupK2PreviewProps = OwnProps;

function Annex6V2GroupK2Preview(props: Annex6V2GroupK2PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupK2;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemK2P1 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'K', '2', renderItemP1()],
            [null, null, 'NOTE', record.remarks],
        ];

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        return (
            <h4 className="font-medium uppercase">
                Changeover to compliant fuel commenced on {itemK2P1.date} at{' '}
                {itemK2P1.time} (SMT)
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupK2Preview;
